import { UIBox } from '@/components/ui/Box';
import { UICheckbox } from '@/components/ui/Checkbox';
import { colors } from '@/theme';
import { DatePicker } from '@material-ui/pickers';
import styled from 'styled-components';

export const StyledTitle = styled('div')`
  display: flex;
  justify-content: center;
  margin: 16px 0 8px 0;
`;

export const StyledWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin: 0;
`;

export const StyledTab = styled('div')`
  width: 100%;
  margin: 0;
  padding: 24px;
`;

export const StyledCalendarWrapper = styled(UIBox)<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: column;

  .helper {
    min-height: 20px; /* stessa altezza dell'helper reale */
    color: rgba(0, 0, 0, 0.54);
    margin: 0;
    font-size: 0.75rem;
    margin-top: 3px;
    text-align: left;
    font-family: AvenirLTPro-Medium;
    font-weight: 400;
    line-height: 1.66;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  display: flex;

  .MuiFormLabel-root.Mui-disabled {
    color: #ccc !important;
  }

  .MuiOutlinedInput-root.Mui-disabled {
    input {
      border-radius: 4px;
      background: #e8e7e7 !important;

      &::placeholder {
        color: #4b4b4b;
      }
    }

    fieldset {
      border-color: #e8e7e7 !important;
      cursor: arrow;
    }
  }
`;

export const StyledFilters = styled(UIBox)`
  display: flex;
  gap: 24px;
  width: 100%;
  margin: 0 auto;
`;

export const StyledDateFiltersWrapper = styled(UIBox)`
  display: flex;
  flex-direction: column;
  flex: 2;
`;

export const StyledDateWrapper = styled(UIBox)`
  display: flex;
  gap: 24px;
  flex: 1;
  padding-top: 8px;
`;

export const StyledDeliveryNumberFilterWrapper = styled(UIBox)`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const StyledAutocompleteWrapper = styled('div')`
  display: flex;
  height: 100%;

  && {
    label {
      color: #4b4b4b !important;
    }
  }

  && {
    fieldset {
      border-color: rgba(0, 0, 0, 0.23) !important;
    }
  }
  .MuiTextField-root {
    border-radius: 4px;
    margin-bottom: 0;
    margin-top: auto;
    width: 100%;
    .MuiOutlinedInput-root {
      &.Mui-disabled {
        background: ${colors.lightGrey} !important;
      }
    }
  }
`;

export const StyledActiveTabFilters = styled(UIBox)`
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;
  justify-content: flex-end;
  padding: 0 8px 0 0;
`;

export const StyledCheckboxWrapper = styled(UIBox)`
  display: flex;
  align-items: center;
`;

export const StyledCheckbox = styled(UICheckbox)`
  &&& {
    margin: 0 8px !important;
    width: 32px;
    height: 32px;
  }
`;

export const StyledNoContentWrapper = styled(UIBox)`
  width: 100%;
  height: 100%;
  min-height: 425px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
